// Copyright (c) 2025. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

export default {
  translation: {
    general_cancel: 'Abbrechen',
    general_delete: 'Löschen',
    general_save: 'Speichern',
    general_back: 'Zurück',
    general_okay: 'Okay',
    general_loading: 'Loading',
    general_close: 'Schliessen',
    general_add: 'Hinzufügen',
    general_yes: 'Ja',
    general_no: 'Nein',

    login: 'Anmelden',
    login_wrong_credentials: 'Falscher Benutzername oder Passwort.',
    auth_or: 'oder',
    auth_sign_in_google: 'Mit Google anmelden',
    auth_sign_in_microsoft: 'Mit Microsoft anmelden',
    auth_no_account: 'Kein Konto gefunden. Bitte kontaktieren Sie Ihren Administrator.',
    auth_popup_blocked: 'Pop-up wurde vom Browser blockiert. Bitte erlauben Sie Pop-ups und versuchen Sie es erneut.',
    auth_network_error: 'Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
    auth_link_existing_account:
      'Ein Konto mit dieser E-Mail existiert bereits. Bitte melden Sie sich mit Ihrem Passwort an, um die Konten zu verknüpfen.',
    auth_link_email_mismatch:
      'Bitte melden Sie sich mit derselben E-Mail an, die Sie im Social-Login-Pop-up verwendet haben, um die Konten zu verknüpfen.',
    auth_link_failed: 'Der Social-Login konnte nicht mit Ihrem Konto verknüpft werden. Bitte versuchen Sie es erneut.',
    auth_email: 'E-Mail',
    auth_password: 'Passwort',

    navbar_hello: 'Hi',

    deliveries_title: 'Lieferungen',
    deliveries_bale_feed_title: 'Förderband Beschickung',
    deliveries_loading: 'laden',
    deliveries_new: 'Neue Lieferung',

    delivery: 'Lieferung',
    delivery_images_delivery: 'Fotos Lieferung',
    delivery_images_bales: 'Fotos Ballen',
    delivery_bales_detected: 'Ballen detektiert',
    delivery_confirm_complete: 'Lieferung abgeschlossen?',
    delivery_confirm_complete_info: 'Eingaben bestätigen und Lieferungserfassung abschliessen?',
    delivery_confirm_delete: 'Lieferung löschen?',
    delivery_confirm_delete_info:
      'Diese Aktion kann nicht rückgängig gemacht werden. Dies wird die Lieferung und alle assoziierten Daten dauerhaft löschen.',
    delivery_import: 'Lieferung aktualisieren',
    delivery_import_success: 'Ballen erfolgreich in Lieferung importiert!',
    delivery_confirm_delete_image: 'Foto löschen?',
    delivery_confirm_delete_image_description:
      'Diese Aktion kann nicht rückgängig gemacht werden. Dies wird das Foto und alle assoziierten Daten dauerhaft löschen.',
    delivery_confirm_delete_image_info: 'Alle assoziierten Ballen werden ebenfalls dabei entfernt.',
    delivery_bale_detection_no_bales_detected: 'Es wurden keine Ballen detektiert.',
    delivery_bale_detection_error:
      'Ein Fehler ist während der Ballen Detektion aufgetreten. Keine Sorge, versuche es erneut oder mache weiter Fotos von der Lieferung.',
    delivery_recompute_detection: 'Nochmal versuchen',
    complete_delivery_save_draft: 'Als Entwurf speichern',
    complete_delivery_complete: 'Erfassung abschliessen',

    // Image Quality Warnings
    image_quality_warning_short: 'Alle Warnungen aufgelöst.',
    affected_images_skipped: 'Status: betroffene Bilder übersprungen',
    image_quality_warning: 'Bildqualitäts-Warnung',
    quality_issues_suggestion: 'Bitte Foto erneut aufnehmen oder ohne Analyse fortfahren.',
    bales_selected_with_issues: '{{count}} von {{total}} Ballen mit Problemen ausgewählt',
    analysis_ready: 'Analyse bereit',
    image_not_analyzed: 'Nicht Analysiert',

    // AI Analysis Section
    ai_analysis: 'KI-Analyse',
    no_ai_analysis_available: 'Es ist keine KI-Analyse für die Lieferung verfügbar.',
    no_data: 'keine Daten',
    company_benchmark: '{{company}} Benchmark',
    industry_benchmark: 'Industrie-Massstab für ',
    outliers: 'Anomalien',
    bales_analyzed: 'Analysierte Ballen',
    issues: 'Probleme',
    problem_delivery_photos: 'Fotos mit Bild-Qualitäts-Problemen',
    problem_bales: 'Nicht analysierte Ballen',
    see_more: 'mehr anzeigen',
    show_less: 'weniger anzeigen',
    contaminants: 'Verunreinigungen',
    no_contamination: 'Keine Verunreinigungen erkannt',
    total: 'gesamt',
    brown_paper_content: 'Braunanteil',
    // no contaminations in this delivery.
    no_contamination_detected_message: 'Keine Verunreinigungen oder Anomalien in dieser Lieferung erkannt',
    no_issues: 'keine Probleme',
    no_image_errors_detected: 'Alle ausgewählten Bilder analysiert. Keine Verarbeitungsfehler gefunden.',
    type_detected: 'Verunreinigungstyp erkannt',
    types_detected: 'Verunreinigungstypen erkannt',
    no_bales_analyzed_brown_content_message:
      'Keine Ballen für Braunanteil analysiert. Fotos haben schlechte Qualität oder sind von der Stirnseite der Ballen. Bitte Fotos erneut aufnehmen, um die Analyse zu sehen',
    no_historical_data_supplier_benchmarks_message:
      'Keine historischen Daten für Industrie-Massstab verfügbar. Mehr Lieferungen erforderlich, um Industrie- und Lieferantendurchschnitte zu berechnen',
    material_match: 'Material Match',
    expected: 'Erwartet',
    material_mismatch_breakdown: 'Auflistung der Abweichungen',
    material_mismatch_breakdown_description: 'Ballen mit Materialabweichungen pro Kategorie',
    material_mismatch_complete_match_message: 'Alle Ballen entsprechen der Materialkategorie der Lieferung',
    match: 'Übereinstimmung',
    mismatch: 'Abweichung',
    mismatch_rate: 'Abweichungsrate',
    mismatch_analysis_summary_tooltip:
      'Total analysierte Ballen: {{analyzed}}\nDavon übereinstimmend mit Lieferung: {{matchCount}} ({{matchPercentage}}%)\n{{mismatchCount}} Ballen weichen vom Material der Lieferung ab.\n',

    claim: 'Reklamation',
    claim_photos: 'Fotos Reklamation',
    claim_linked_bales: 'Verlinkte Ballen & Bilder',
    claim_confirm: 'Bestätigen & Einreichen',
    claim_send_confirm_title: 'Möchtest Du eine Benachtigung für die Reklamation versenden?',
    claim_send_warning: 'Benachrichtigung wurde bereits gesendet!',
    claim_send: 'Senden',
    claim_send_confirmation: 'Benachrichtigung erfolgreich gesendet!',
    claim_not_sent_confirmation: 'Reklamation gespeichert. Es wurden keine Emails versendet.',
    claim_notes: 'Notizen',
    claim_notes_placeholder: 'Zusätzliche Details zur Reklamation...',

    scanned_document_extraction_success: 'Informationen erfolgreich extrahiert.',
    scanned_document_extraction_running: 'Extrahiere Informationen...',
    scanned_document_extraction_error: 'Extrahieren fehlgeschlagen. Versuche es erneut.',
    scanned_document_extraction_info: 'Nimm ein Foto des Wiegescheins um automatisch Informationen zu extrahieren.',
    scanned_document_take_picture: 'Mach ein Foto',

    instructions_import_bales: 'Anleitung: Ballen Importieren',
    instructions_scan_truck: 'Anleitung: Truck Scannen',

    labeling_panel_toggle: 'Labeling Panel',
    labeling_title: 'Labeling',

    property_field_extendable_new: 'Neuen Eintrag erfassen?',
    property_notes: 'NOTIZEN',
    property_supplier: 'LIEFERANT',
    property_storage_field: 'LAGER FELD',
    property_date: 'DATUM',
    property_submitted_by: 'ERFASSER',
    property_problems: 'PROBLEMPUNKTE',
    property_material: 'MATERIAL',
    property_material_group: 'MATERIAL GRUPPE',
    property_document_scanner: 'DOKUMENT SCANNER',
    material_properties: 'Materialeigenschaften',
    property_supplier_no: 'LIEFERANTEN NR',
    property_supplier_name: 'LIEFERANTEN NAME',
    property_order_no: 'BESTELL NR',
    property_license_plate: 'KENNZEICHEN LKW',
    property_weight_first: '1. WÄGUNG',
    property_weight_second: '2. WÄGUNG',
    property_weight_netto_1: 'NETTO I',
    property_weight_netto_2: 'NETTO II',
    property_doc_type: 'DOKUMENT TYP',
    property_slip_nr: 'DOKUMENT NR',

    delivery_documents_scanned: 'Dokumente',
    document_type_weighing_slip: 'Wiegeschein',
    document_type_delivery_slip: 'Lieferschein',

    bale_feed_no_data: 'Keine Daten',
    bale: 'Balle',
    bales: 'Ballen',
    material: 'Material',

    // Shared Components
    labeling_select_recommended: 'Empfohlen',
    labeling_select_others: 'Andere',
    labeling_request: 'Labeling Anfrage',
    labeling_skip: 'Unbestimmt lassen',
    labeling_no_more_requests: 'Keine weiteren labeling Anfragen gefunden.',
    license_agreement_title: 'Lizenzvereinbarung',
    license_agreement_decline: 'Ablehnen',
    license_agreement_accept: 'Akzeptieren',

    access_denied_back_to_login: 'Zurück zur Anmeldung',
    access_denied_contact_admin: 'Kontaktiere Administrator',
    access_denied_support_email: 'support@upcircle.com',
    access_denied_copyright: 'UpCircle © 2025',
    access_denied_title: 'Zugriff verweigert',
    access_denied_message:
      'Diese Anwendung benötigt eine initiale Einrichtung durch den Systemadministrator, bevor sie zugänglich ist.',
  },
};
